import { defineComponent as _defineComponent } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'About',
  setup(__props) {

// import HelloWorld from '@/components/HelloWorld.vue'

return (_ctx: any,_cache: any) => {
  return " About "
}
}

})